import React from "react";
import {
  Modal,
  Box,
  Button,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Chip,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const formatFechaTicket = (fecha) => {
  if (!fecha) return "Sin fecha";

  return new Date(fecha).toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const formatPrecio = (precio) => {
  const numero = Number(precio || 0);
  return `${numero.toFixed(2)} €`;
};

const EditarUsuario = ({
  open,
  onClose,
  formData,
  historial = [],
  onFormChange,
  onSubmit,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-editar-cliente"
    >
      <Box className="modal-edicion">
        <h2 className="titulo-modal">Información Cliente</h2>

        <form onSubmit={onSubmit} className="formulario-edicion">
          <Box
            sx={{
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
            }}
          >
            <TextField
              label="Nombre"
              name="nombre"
              value={formData.nombre || ""}
              onChange={onFormChange}
              required
              fullWidth
            />

            <TextField
              label="Apellidos"
              name="apellido"
              value={formData.apellido || ""}
              onChange={onFormChange}
              required
              fullWidth
            />
          </Box>

          <TextField
            label="Teléfono"
            name="telefono"
            value={formData.telefono || ""}
            onChange={onFormChange}
            fullWidth
            margin="normal"
          />

          <TextField
            label="Observaciones"
            name="observaciones"
            value={formData.observaciones || ""}
            onChange={onFormChange}
            fullWidth
            margin="normal"
            multiline
            rows={4}
          />

          <Accordion sx={{ mt: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight={600}>
                Últimos tickets
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              {historial.length === 0 ? (
                <Typography variant="body2" color="text.secondary">
                  Este cliente todavía no tiene historial de tickets.
                </Typography>
              ) : (
                [...historial]
  .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
  .map((ticket, index) => (
                  <Box key={ticket.id_ticket || index}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: 2,
                        py: 1.5,
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            flexWrap: "wrap",
                            mb: 0.5,
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ fontWeight: 700 }}
                          >
                            Ticket #{ticket.id_ticket}
                          </Typography>

                          {ticket.tipo_pago && (
                            <Chip
                              label={ticket.tipo_pago}
                              size="small"
                              variant="outlined"
                            />
                          )}
                        </Box>

                        <Typography
                          variant="caption"
                          color="text.secondary"
                        >
                          {formatFechaTicket(ticket.fecha)}
                        </Typography>

                        <Box sx={{ mt: 1 }}>
                          {ticket.detalles && ticket.detalles.length > 0 ? (
                            ticket.detalles.map((detalle) => (
                              <Box
                                key={detalle.id_detalle}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: 2,
                                  py: 0.3,
                                }}
                              >
                                <Typography variant="body2">
                                  {detalle.nombre}
                                  {detalle.cantidad > 1
                                    ? ` x${detalle.cantidad}`
                                    : ""}
                                </Typography>

                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 600 }}
                                >
                                  {formatPrecio(detalle.subtotal || detalle.precio)}
                                </Typography>
                              </Box>
                            ))
                          ) : (
                            <Typography
                              variant="body2"
                              color="text.secondary"
                            >
                              Sin detalles en este ticket
                            </Typography>
                          )}
                        </Box>
                      </Box>

                      <Typography
                        sx={{
                          fontWeight: 800,
                          color: "#16a34a",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {formatPrecio(ticket.total)}
                      </Typography>
                    </Box>

                    {index < historial.length - 1 && <Divider />}
                  </Box>
                ))
              )}
            </AccordionDetails>
          </Accordion>

          <div className="botones-modal">
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className="btn-guardar"
            >
              Guardar
            </Button>

            <Button
              variant="outlined"
              onClick={onClose}
              className="btn-cancelar"
            >
              Cancelar
            </Button>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default EditarUsuario;